import React from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  const projects = [
    {
      title: "Cabin Safe",
      tagline: "B2B/B2C IoT platform for vehicle cabin safety.",
      description: "A cellular-connected, multi-sensor IoT device and SaaS platform that monitors a vehicle's interior environment to prevent heatstroke in children and pets.",
      status: "In Development / Seeking B2B Pilot Partners",
      imageUrl: "/assets/images/CabinSafeLogo.png",
      slug: "smartcabin",
      buttonText: "View the Business Plan"
    },
    {
      title: "PokerJourney",
      tagline: "MicroSaaS for poker performance and bankroll tracking.",
      description: "A live, monetized (V4.0) MicroSaaS that helps players master their mental game. Built on a secure, multi-tenant backend with Stripe subscriptions.",
      status: "Live on the Market",
      imageUrl: "/assets/images/PokerJourneyLogo.png",
      slug: "pokerjourney",
      buttonText: "Visit PokerJourney.app"
    },
    {
      title: "ChapterRelief",
      tagline: "B2B PaaS for the legal tech industry.",
      description: "A platform-as-a-service designed to eliminate manual data entry for bankruptcy attorneys. It securely pulls tri-merge credit reports and formats the data for case software.",
      status: "In Development",
      imageUrl: "/assets/images/ChapterReliefLogo.png",
      slug: "chapterrelief",
      buttonText: "Learn More"
    },
    {
      title: "Turn-Based Robot Battle RPG",
      tagline: "Solo-developed, web-first, cross-platform RPG.",
      description: "An ambitious project to build a complete, web-based RPG where players build and customize robots to fight a rogue AI. The 25-page development plan details a phased MVP, crafting system, and branching narrative.",
      status: "In Development",
      imageUrl: "/assets/images/Subsection%20Social%20Media%20Management.webp",
      slug: "robot-battle-rpg",
      buttonText: "View the Development Roadmap"
    }
  ];

  return (
    <section className="bg-color-dark py-48 px-24 mt-8">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <h2 className="text-white text-center text-42px mb-24" id="portfolio">The Products</h2>
        <p className="text-white text-center mb-48 mx-auto" style={{ maxWidth: 640 }}>
          Portfolio of ambitious, solo-architected systems.
        </p>
        <div className="grid grid-cols-1 mb-8 md:grid-cols-2" style={{ gap: 48 }}>
          {projects.map((project, idx) => (
            <div key={idx} className="bg-accent-dark br-5 p-24" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={project.imageUrl} alt={project.title} className="w-full br-5 mb-16 mt-8" style={{ height: 180, maxHeight: 180, objectFit: 'contain', backgroundColor: 'transparent' }} />
              <h3 className="text-white text-24px mb-8 text-center">{project.title}</h3>
              <p className="text-white mb-12 text-center">{project.tagline}</p>
              <p className="text-white text-14px mb-12 text-center">{project.description}</p>
              <span className="text-secondary-dark text-14px block mb-16 text-center">{project.status}</span>
              <div className="mt-16 mb-8">
                <Link className="mb-8" to={`/projects/${project.slug}`}>
                  <button className="px-24 py-12 mb-8 primary-color-dark no-border bold br-5 nav-button">
                    {project.buttonText}
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;

